import Phaser from 'phaser'
import {
    CST
} from '../CST'

export default class PreloadScene extends Phaser.Scene {

    constructor() {
        super(CST.SCENES.PRELOAD);
    }

    preload() {
        this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, "loading_bg");

        // Sounds

        this.load.audio("clickSound", "assets/Sounds/Click/3. 448080__breviceps__wet-click.mp3");
        this.load.audio("congratsSound", "assets/Sounds/Congratulations/430925__higgs01__yipee.mp3");
        this.load.audio("correctSound", "assets/Sounds/Correct/335908__littlerainyseasons__correct.mp3");
        this.load.audio("popSound", "assets/Sounds/Pop/260614__kwahmah-02__pop.mp3");
        this.load.audio("timerSound", "assets/Sounds/Timer/3. 487735__mattix__ticking-timer-60-sec.mp3");
        this.load.audio("wrongSound", "assets/Sounds/Wrong/342756__rhodesmas__failure-01.mp3");
        this.load.audio("rollDiceSound", "assets/Sounds/RollDice/Shake And Roll Dice-SoundBible.com-591494296.mp3");
        this.load.audio("pawnMoveSound", "assets/Sounds/PawnMove/Click2-Sebastian-759472264.mp3");

        // Backgrounds 

        this.load.image("black_screen", "assets/black_screen.png");
        this.load.image("main_background", "assets/main_background.png");
        this.load.image("start_background", "assets/start_background.png");
        this.load.image("board_background", "assets/board.png");
        this.load.image("rules1", "assets/RulesPage.jpg");
        this.load.image("rules2", "assets/RulesPage2.jpg");
        this.load.image("blank_background", "assets/blank_background.jpg");

        // Buttons

        this.load.image("btn_play", "assets/play_button.png");
        this.load.image("btn_back", "assets/BackToGame.png");
        this.load.image("btn_rules", "assets/RulesHome.png");
        this.load.image("btn_rules2", "assets/RulesGame.png");
        this.load.image("btn_play_again", "assets/play_again.png");
        this.load.image("btn_menu", "assets/menu.png");
        this.load.image("btn_next", "assets/next.png");
        this.load.image("btn_roll_dice", "assets/btn_roll_dice.png");
        this.load.image("btn_roll_dice_bw", "assets/btn_roll_dice_bw.png");
        this.load.image("btn_show_answer", "assets/show_answer.png");
        this.load.image("btn_teams2", "assets/2teams.png");
        this.load.image("btn_teams3", "assets/3teams.png");
        this.load.image("btn_teams4", "assets/4teams.png");
        this.load.image('tick', 'assets/tick.png');
        this.load.image('cross', 'assets/cross.png');
        this.load.image("btn_start", "assets/start.png");
        this.load.image("btn_forward", "assets/forward.png");
        this.load.image("btn_backward", "assets/backward.png");

        // Extras

        this.load.image("pop_up_end", "assets/game over popup.png");
        this.load.image("congratulations", "assets/congratulations.png"); 
        this.load.image("leaderboard2", "assets/leaderboard-popup2.png");
        this.load.image("leaderboard3", "assets/leaderboard-popup3.png");
        this.load.image("leaderboard4", "assets/leaderboard-popup4.png");
        this.load.image("time_up", "assets/time_up.png");
        this.load.image("green_piece", "assets/green_piece.png");
        this.load.image("yellow_piece", "assets/yellow_piece.png");
        this.load.image("red_piece", "assets/red_piece.png");
        this.load.image("purple_piece", "assets/purple_piece.png");
        this.load.image("game_over_text", "assets/game_over.png");
        this.load.image("team_name_too_long", "assets/team_name_too_long.png");
        this.load.image("team_name_box", "assets/team_name_box.png");
        this.load.image("team_name_box_yellow", "assets/team_yellow.png");
        this.load.image("team_name_box_green", "assets/team_green.png");
        this.load.image("team_name_box_red", "assets/team_red.png");
        this.load.image("team_name_box_purple", "assets/team_purple.png");
        this.load.image("red_name_box", "assets/red name.png");
        this.load.image("green_name_box", "assets/green name.png");
        this.load.image("yellow_name_box", "assets/yellow name.png");
        this.load.image("purple_name_box", "assets/purple name.png");

        //Discussion cards

        this.load.image("d1", "assets/Discussions/D1.png");
        this.load.image("d2", "assets/Discussions/D2.png");
        this.load.image("d3", "assets/Discussions/D3.png");
        this.load.image("d4", "assets/Discussions/D4.png");
        this.load.image("d5", "assets/Discussions/D5.png");
        
        // SpriteSheets

        this.load.spritesheet({
            key: "dice",
            url: "assets/dice_spritesheet.png",
            frameConfig: {
                frameWidth: 111,
                frameHeight: 121
            }
        });

        this.load.spritesheet({
            key: "dice_rolling",
            url: "assets/rolling-dice_spritesheet.png",
            frameConfig: {
                frameWidth: 112,
                frameHeight: 123
            }
        });

        this.load.spritesheet({
            key: "firework-blue",
            url: "assets/firework-blue.png",
            frameConfig: {
                frameWidth: 384.03,
                frameHeight: 385
            }
        });
        this.load.spritesheet({
            key: "firework-yellow",
            url: "assets/firework-yellow.png",
            frameConfig: {
                frameWidth: 384.03,
                frameHeight: 385
            }
        });

        this.load.spritesheet({
            key: "flag",
            url: "assets/flag_sprite.png",
            frameConfig: {
                frameWidth: 96,
                frameHeight: 141
            }
        });

        this.load.plugin("rexinputtextplugin", "https://raw.githubusercontent.com/rexrainbow/phaser3-rex-notes/master/dist/rexinputtextplugin.min.js", !0);

        this.load.on('complete', () => {
            this.scene.start(CST.SCENES.MENU)
        });
    }

    create() {}

    upload() {}
}